import React, {createContext, useContext, useState} from "react";

const AppContext = createContext();

export function AppProvider({ children }) {
    const [isLoading, setIsLoading] = useState(null);
    const setLoading = (state) => setIsLoading(state);

    return (
        <AppContext.Provider value={{setLoading, isLoading}}>
            {children}
        </AppContext.Provider>
    );
}

export function useAppContext() {
    return useContext(AppContext)
}